import { render, staticRenderFns } from "./PlatformList.vue?vue&type=template&id=17b2e9d0"
import script from "./PlatformList.vue?vue&type=script&lang=js"
export * from "./PlatformList.vue?vue&type=script&lang=js"
import style0 from "./PlatformList.vue?vue&type=style&index=0&id=17b2e9d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports